import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "classes", "id", "label", "value"];
import React from 'react';
import { Circle } from 'react-feather';
import { node, shape, string } from 'prop-types';
import { Radio as InformedRadio } from 'informed';
import { useStyle } from '../../classify';
import defaultClasses from './radio.module.css';
/* TODO: change lint config to use `label-has-associated-control` */

/* eslint-disable jsx-a11y/label-has-for */

var RadioOption = function RadioOption(props) {
  var ariaLabel = props.ariaLabel,
      propClasses = props.classes,
      id = props.id,
      label = props.label,
      value = props.value,
      rest = _objectWithoutProperties(props, _excluded);

  var classes = useStyle(defaultClasses, propClasses);
  return React.createElement("label", {
    className: classes.root,
    htmlFor: id,
    "aria-label": ariaLabel ? ariaLabel : ''
  }, React.createElement(InformedRadio, _extends({}, rest, {
    className: classes.input,
    id: id,
    value: value
  })), React.createElement("span", {
    className: classes.icon
  }, React.createElement(Circle, null)), React.createElement("span", {
    className: classes.label
  }, label || (value != null ? value : '')));
};

export default RadioOption;
RadioOption.propTypes = {
  ariaLabel: string,
  classes: shape({
    icon: string,
    input: string,
    label: string,
    root: string
  }),
  id: string.isRequired,
  label: node.isRequired,
  value: node.isRequired
};
/* eslint-enable jsx-a11y/label-has-for */